"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const WizardModal = ({ children, leftHeaderElement, rightHeaderElement, progress, leftToolbarElement, rightToolbarElement, device, }) => {
    const headerStyle = {
        minHeight: 56,
        width: '100%',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        padding: device !== 'Mobile' ? '0 32px' : '0 24px',
    };
    const toolbarStyle = {
        minHeight: 79,
        width: '100%',
        backgroundColor: src_1.almostWhite,
        borderTop: `1px solid ${src_1.titanium}`,
        flex: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: device !== 'Mobile' ? '0 32px' : '0 24px',
    };
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            border: `1px solid ${src_1.titanium}`,
        } },
        React.createElement("div", { style: headerStyle },
            leftHeaderElement,
            rightHeaderElement),
        progress ? (React.createElement(src_1.ProgressBarThin, { progress: progress, barPropStyle: {
                width: '100%',
                flex: '0 0 auto',
            }, progressPropStyle: {
                transition: 'width 500ms ease',
            } })) : (React.createElement("div", { style: { height: 1, width: '100%', background: src_1.titanium } })),
        React.createElement("div", { id: "wizardModalBody", style: {
                flex: '1 1 auto',
                position: 'relative',
            } },
            React.createElement("style", { type: "text/css" }, `
                        #wizardModalBody {                        
                            -webkit-transform: translateZ(0px);
                            -webkit-transform: translate3d(0,0,0);
                            -webkit-perspective: 1000;
                        }                                          
                    `),
            children),
        React.createElement("div", { style: toolbarStyle },
            rightToolbarElement,
            leftToolbarElement)));
};
exports.default = WizardModal;
